(ns frontend.view.modals.view
  (:require
   [reagent.core :as r]
   [reagent.ratom :as ratom]
   [frontend.state.current-session :as session]
   [frontend.view.modals.events :as events]
   [frontend.view.modals.db :as db]

   [frontend.view.modals.delete-confirmation.view :as delete-confirmation]
   [frontend.view.modals.delete-confirmation.check-usage-view :as delete-confirmation-check-usage]
   [frontend.view.modals.stage-delete.view :as stage-delete]
   [frontend.view.modals.opportunity-stage-delete.view :as opportunity-stage-delete]
   [frontend.view.modals.sales-opportunity-stage-delete.view :as sales-opportunity-stage-delete]
   [frontend.view.modals.exit-opportunity-stage-delete.view :as exit-opportunity-stage-delete]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.ratings.deal :as deal-ratings]
   [frontend.view.modals.error-message.view :as error-message]
   [frontend.view.modals.notification.view :as notification]
   [frontend.view.modals.session-timeout.view :as session-timeout]
   [frontend.view.modals.account-invite.view :as account-invite]
   [frontend.view.modals.account-disable.view :as account-disable]
   [frontend.view.modals.ai-deal-one-pager.view :as ai-deal-one-pager]
   [frontend.view.modals.memo.view :as memo]
   [frontend.view.modals.new-kpi-cycle.view :as new-kpi-cycle]
   [frontend.view.modals.new-kpi-report.view :as new-kpi-report]
   [frontend.view.modals.kpi-email.view :as kpi-email]
   [frontend.view.modals.textarea.view :as textarea-modal]
   [frontend.view.modals.email-editor.view :as email-editor-modal]
   [frontend.view.modals.email-viewer.view :as email-viewer-modal]
   [frontend.view.modals.nylas-connect.view :as nylas-connect-modal]

   [frontend.view.modals.curtains.settings-curtain.view :as field-settings-curtain]
   [frontend.view.modals.curtains.filter-curtain.view :as filter-curtain]
   [frontend.view.modals.curtains.kpi-member-curtain.view :as kpi-member-curtain]
   [frontend.view.modals.curtains.tag-curtain.view :as tag-curtain]
   [frontend.view.modals.curtains.pass-curtain.view :as pass-curtain]
   [frontend.view.modals.curtains.put-on-hold-curtain.view :as put-on-hold-curtain]
   [frontend.view.modals.curtains.pipeline-settings-curtain.view :as pipeline-settings-curtain]
   [frontend.view.modals.curtains.column-selector-curtain.view :as column-selector-curtain]
   [frontend.view.modals.curtains.delete-option-curtain.view :as delete-option-curtain]
   [frontend.view.modals.curtains.merge-option-curtain.view :as merge-option-curtain]
   [frontend.view.modals.curtains.nev-editor-curtain.view :as nev-editor-curtain]

   [frontend.view.modals.account-select.view :as account-select]
   [frontend.view.modals.change-password.view :as change-password]
   [frontend.view.modals.choice-confirmation.view :as choice-confirmation]
   [frontend.view.modals.association.view :as association-editor]
   [frontend.view.modals.activity-entity-editor.view :as activity-editor]
   [frontend.view.modals.video.view :as video]
   [frontend.view.modals.entity.view :as entity]
   [frontend.view.modals.custom-entity-creator.model :as custom-entity-creator-m]
   [frontend.view.modals.custom-entity-creator.view :as custom-entity-creator]
   [frontend.view.modals.entry-criteria.model :as entry-criteria-m]
   [frontend.view.modals.entry-criteria.view :as entry-criteria]
   [frontend.view.modals.entity-editor.view :as entity-editor]
   [frontend.view.modals.entity-audit-trail.view :as entity-audit-trail]
   [frontend.view.modals.pre-investment-check.view :as pre-investment-check]
   [frontend.view.modals.pre-exit-check.view :as pre-exit-check]
   [frontend.view.modals.entity-esign.view :as entity-esign]
   [frontend.view.settings2.e-signature.view :as esign-settings]
   [frontend.view.modals.attachments.view :as attachments]
   [frontend.view.modals.review.view :as review]
   [frontend.view.modals.dynamic.view :as dynamic]
   [frontend.view.modals.account-reactivate.view :as account-reactivate]
   [frontend.view.modals.account-edit.view :as account-edit]
   [frontend.view.modals.processing.view :as processing]
   [frontend.view.modals.guest-invite.view :as guest-invite]
   [frontend.view.modals.team-edit.view :as team-edit]
   [frontend.view.modals.pipeline-edit.view :as pipeline-edit]
   [frontend.view.modals.fund-edit.view :as fund-edit]
   [frontend.view.modals.single-reference-relationship.view :as single-reference-relationship]
   [frontend.view.modals.curtains.fundraising-opportunity.lost-curtain :as
    curtain-fundraising-opportunity-loss]
   [frontend.view.modals.curtains.fundraising-opportunity.on-hold-curtain :as
    curtain-fundraising-opportunity-hold]
   [frontend.view.modals.curtains.sales-opportunity.lost-curtain :as curtain-sales-opportunity-loss]
   [frontend.view.modals.curtains.sales-opportunity.on-hold-curtain :as
    curtain-sales-opportunity-hold]
   [frontend.view.modals.curtains.exit-opportunity.lost-curtain :as curtain-exit-opportunity-loss]
   [frontend.view.modals.curtains.exit-opportunity.on-hold-curtain :as
    curtain-exit-opportunity-hold]
   [frontend.view.modals.select-asset-type.view :as select-asset-type]
   [frontend.view.modals.copy-permissions.view :as copy-permissions]
   [frontend.view.modals.change-pipeline.view :as change-pipeline]
   [frontend.view.modals.curtains.tenant-custom-filter-curtain.view :as
    tenant-custom-filter-curtain]
   [frontend.view.modals.select-entity.view :as select-entity]
   [frontend.view.modals.options-management.view :as options-management]
   [frontend.view.modals.value-creation.view :as value-creation]
   [frontend.view.modals.layout-editor.view :as layout-editor]
   [frontend.view.modals.risk-editor.view :as risk-editor]
   [basic-components.modal :as zap-modal]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [frontend.ux-overhaul.nev.interim.edit-oppo-name-modal :as interim-edit-oppo-name]
   [frontend.view.modals.decisions.view :as decision-modal]
   [frontend.view.modals.folder-management-modal.view :as folder-management-modal]
   [frontend.view.modals.folder-selection-modal.view :as folder-selection-modal]
   [frontend.view.modals.folder-management-check-lists-modal.view :as folder-management-check-lists-modal]
   [frontend.view.modals.survey-template-email-editor.view :as survey-template-email-editor-modal]
   [frontend.view.modals.survey-template-thank-you-editor.view :as survey-template-thank-you-editor-modal]
   [frontend.view.modals.survey-cycle-actions.view :as survey-cycle-actions-modal]
   [frontend.view.modals.hidden-emails.view :as hidden-emails-modal]))

;; Include the modals here giving it a unique key
(def modal-components
  {delete-confirmation/modal-key delete-confirmation/view
   delete-confirmation-check-usage/modal-key delete-confirmation-check-usage/view
   stage-delete/modal-key stage-delete/view
   opportunity-stage-delete/modal-key opportunity-stage-delete/view
   sales-opportunity-stage-delete/modal-key sales-opportunity-stage-delete/view
   exit-opportunity-stage-delete/modal-key exit-opportunity-stage-delete/view
   deal-ratings/modal-key deal-ratings/view
   confirmation/modal-key confirmation/view       ;; settings - target reporting - enable target reporting (requires target reporting not having been set)
   error-message/modal-key error-message/view     ;; settings - try to delete a stage that has active deals on it
   notification/modal-key notification/view       ;; kpi-report - submit report
   session-timeout/modal-key session-timeout/view ;; global navbar temp button
   account-invite/modal-key account-invite/view   ;; settings - users - invite
   memo/modal-key memo/view                       ;; deal view - secondary dropdown - memorandum (only for 'Demo Ventures', create such tenant)
   new-kpi-cycle/modal-key new-kpi-cycle/view     ;; kpi-categories
   new-kpi-report/modal-key new-kpi-report/view   ;; kpi-categories
   kpi-email/modal-key kpi-email/view             ;; kpi-company-reports
   textarea-modal/modal-key textarea-modal/view   ;; settings - fields - user guidance
   field-settings-curtain/modal-key field-settings-curtain/view
   filter-curtain/modal-key filter-curtain/view
   kpi-member-curtain/modal-key kpi-member-curtain/view
   tag-curtain/modal-key tag-curtain/view
   pass-curtain/modal-key pass-curtain/view
   put-on-hold-curtain/modal-key put-on-hold-curtain/view
   pipeline-settings-curtain/modal-key pipeline-settings-curtain/view
   column-selector-curtain/modal-key column-selector-curtain/view
   account-select/modal-key account-select/view
   change-password/modal-key change-password/view
   choice-confirmation/modal-key choice-confirmation/view
   association-editor/modal-key association-editor/view
   video/modal-key video/view
   account-disable/modal-key account-disable/view ;; settings - users - invite
   ai-deal-one-pager/modal-key ai-deal-one-pager/view
   entity/modal-key entity/view
   custom-entity-creator-m/modal-key custom-entity-creator/view
   custom-entity-creator-m/opportunity-modal-key custom-entity-creator/opportunity-curtain-view
   custom-entity-creator-m/investor-modal-key custom-entity-creator/investor-curtain-view
   entry-criteria-m/modal-key entry-criteria/view
   entity-editor/modal-key entity-editor/view
   pre-investment-check/modal-key pre-investment-check/view
   pre-exit-check/modal-key pre-exit-check/view
   entity-esign/modal-key entity-esign/view
   esign-settings/modal-key esign-settings/view
   risk-editor/modal-key risk-editor/view
   email-editor-modal/modal-key email-editor-modal/view
   email-viewer-modal/modal-key email-viewer-modal/view
   nylas-connect-modal/modal-key nylas-connect-modal/view
   attachments/modal-key attachments/view
   review/modal-key review/view
   dynamic/modal-key dynamic/view
   account-reactivate/modal-key account-reactivate/view
   account-edit/modal-key account-edit/view
   processing/modal-key processing/view
   guest-invite/modal-key guest-invite/view
   team-edit/modal-key team-edit/view
   pipeline-edit/modal-key pipeline-edit/view
   fund-edit/modal-key fund-edit/view
   single-reference-relationship/modal-key single-reference-relationship/view
   curtain-fundraising-opportunity-loss/modal-key curtain-fundraising-opportunity-loss/view
   curtain-fundraising-opportunity-hold/modal-key curtain-fundraising-opportunity-hold/view
   curtain-sales-opportunity-loss/modal-key curtain-sales-opportunity-loss/view
   curtain-sales-opportunity-hold/modal-key curtain-sales-opportunity-hold/view
   curtain-exit-opportunity-loss/modal-key curtain-exit-opportunity-loss/view
   curtain-exit-opportunity-hold/modal-key curtain-exit-opportunity-hold/view
   select-asset-type/modal-key select-asset-type/view
   copy-permissions/modal-key copy-permissions/view
   change-pipeline/modal-key change-pipeline/view
   tenant-custom-filter-curtain/modal-key tenant-custom-filter-curtain/view
   select-entity/modal-key select-entity/view
   zap-modal/modal-key zap-modal/view
   delete-option-curtain/modal-key delete-option-curtain/view
   merge-option-curtain/modal-key merge-option-curtain/view
   options-management/modal-key options-management/view
   value-creation/modal-key value-creation/view
   layout-editor/modal-key layout-editor/view
   nev-editor-curtain/modal-key nev-editor-curtain/view
   decision-modal/modal-key decision-modal/view
   folder-management-modal/modal-key folder-management-modal/view
   folder-management-check-lists-modal/modal-key folder-management-check-lists-modal/view
   survey-template-email-editor-modal/modal-key survey-template-email-editor-modal/view
   survey-template-thank-you-editor-modal/modal-key survey-template-thank-you-editor-modal/view
   survey-cycle-actions-modal/modal-key survey-cycle-actions-modal/view
   folder-selection-modal/modal-key folder-selection-modal/view
   hidden-emails-modal/modal-key hidden-emails-modal/view
   entity-audit-trail/modal-key entity-audit-trail/view

   ; Interim nev
   interim-edit-oppo-name/modal-key interim-edit-oppo-name/view})

(defonce kpi-module-required
         [kpi-member-curtain/modal-key
          new-kpi-cycle/modal-key
          new-kpi-report/modal-key])

(defonce module-watch
         (r/track! (fn []
                     (let [modules @session/account-modules]
                       ;;if needed, add similar logic for other modules
                       (when (not (some #{:module/kpi-reporting} modules))
                         (swap! db/state #'events/close-modals kpi-module-required)
                         ;; cursor -> propagate
                         (deref db/state))))))

(defn view
  []
  (let [custom-modal? (fn [{:keys [modal-type]}]
                        (= modal-type activity-editor/modal-key))
        ;; Creating a comprehensive signal graph here for reference / as an exercise. Each individual
        ;; reaction works as a computation limit that is recalculated only when the contents
        ;; of the deref'd objects change. The effect on performance / rerendering
        ;; here is negligible, but this level of splitting might be necessary when
        ;; high performance is required.
        r-all-modals (ratom/reaction
                      (vals @db/state))
        r-custom-modals (ratom/reaction
                         (->> @r-all-modals
                              (filter custom-modal?)
                              doall))
        r-visible-modals (ratom/reaction
                          (->> @r-all-modals
                               (filter :shown?)
                               doall))
        r-sorted-modals (ratom/reaction
                         (->> @r-visible-modals
                              (sort-by :order)))
        r-sorted-default-modals (ratom/reaction
                                 (->> @r-sorted-modals
                                      (remove custom-modal?)
                                      doall))
        r-topmost (ratom/reaction
                   (->> @r-sorted-modals
                        last))]
    (fn []
      (let [topmost @r-topmost
            custom-modals @r-custom-modals
            sorted-modals @r-sorted-default-modals]
        [:div
         [:div.custom-modals
          {:class "z-10"}
          (doall
           (for [{:keys [order] :as modal-props} custom-modals]
             ^{:key (str "modal__" order)}
             [activity-editor/view
              (assoc modal-props
                     :topmost?
                     (= topmost modal-props))]))]
         [:div.react-modals
          (doall
           (for [{:keys [order modal-type] :as modal-props} sorted-modals
                 :let [modal-comp (get modal-components modal-type)
                       state (r/cursor db/state [order :state])
                       _ (when (not modal-comp)
                           (logging/error "Misconfigured MODAL !! " modal-type))]]
             ^{:key (str "modal__" order "_" modal-type)}
             [modal-comp
              (assoc modal-props
                     :state state
                     :class-name (fu/cs @(r/track session/tenant-class-name))
                     :topmost? (= topmost modal-props))]))]]))))
